import { createSlice } from '@reduxjs/toolkit';
import { getProducts } from '../actions/ProductsActions';

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    products: [],
    getStatus: 'idle',
    errorMessage: null,
  },
  reducers: {
    resetGet(state) {
      state.getStatus = 'idle';
      state.products = [];
    },
  },
  extraReducers: {
    [getProducts.pending]: (state) => {
      state.getStatus = 'loading';
    },
    [getProducts.fulfilled]: (state, action) => {
      state.getStatus = action.payload.status ? 'succeded' : 'error';
      state.products = action.payload.products;
      state.errorMessage = action.payload.status ? null : action.payload.msg;
    },
    [getProducts.rejected]: (state, action) => {
      state.getStatus = 'error';
      state.errorMessage = action.error.message;
    },
  },
});

export const { resetGet } = productsSlice.actions;
export default productsSlice.reducer;
